import React from 'react';
import { useTranslation } from 'react-i18next';

const FlashControls: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <div className="flex flex-wrap gap-3">
        <button
          disabled
          className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
        >
          {t('flash.start')}
        </button>
        <button
          disabled
          className="px-4 py-2 bg-yellow-500 text-white rounded-lg text-sm font-medium hover:bg-yellow-600 disabled:opacity-50"
        >
          {t('flash.eraseOnly')}
        </button>
        <button
          disabled
          className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 disabled:opacity-50"
        >
          {t('flash.verifyOnly')}
        </button>
      </div>
    </div>
  );
};

export default FlashControls;
